import Cookies from "js-cookie"
import {useEffect} from "react"
import {
    MASID_COOKIE_NAME,
    MASID_COOKIE_SEGMENT_KEY_NAME,
    BR_SEARCH_VARIANT_COOKIE_NAME,
    BR_SEG_ID_UNCLASSIFIED,
} from "../../config/constants"

export const useSetSegmentCookie = (useBloomreachSegmentCookie: boolean) => {
    useEffect(() => {
        if (useBloomreachSegmentCookie === true) {
            const masIdCoookieValue = Cookies.get(MASID_COOKIE_NAME)
            let segmentValue = BR_SEG_ID_UNCLASSIFIED

            if (!masIdCoookieValue) {
                Cookies.set(BR_SEARCH_VARIANT_COOKIE_NAME, segmentValue)
                return
            }

            const regex = new RegExp(`(${MASID_COOKIE_SEGMENT_KEY_NAME}_([A-Z]|[a-z]|[0-9])+)`)
            const segmentCookieValue = regex.exec(masIdCoookieValue)
            if (!segmentCookieValue) {
                Cookies.set(BR_SEARCH_VARIANT_COOKIE_NAME, segmentValue)
                return
            }

            segmentValue = segmentCookieValue[0].replace(`${MASID_COOKIE_SEGMENT_KEY_NAME}_`, "")
            Cookies.set(BR_SEARCH_VARIANT_COOKIE_NAME, segmentValue)
        }
    }, [useBloomreachSegmentCookie])
}

export default useSetSegmentCookie
